
















































import { api, dashboardApi } from "@/api/api";
import { ApiGetCustomerDto, ApiGetDashboardCourseAttendanceDto } from "@/api/generated/Api";
import BaseTooltipIconButton from "@/components/shared/button/BaseTooltipIconButton.vue";
import BaseTableFiltered from "@/components/shared/table/BaseTableFiltered.vue";
import { DashboardRouteNames } from "@/shared/enums/RouteNames/dashboardRouteNames.enum";
import { SingleCourseRouteNames } from "@/shared/enums/RouteNames/singleCourseRouteNames.enum";
import { formatLocalizedDate } from "@/shared/helpers/dateHelpers";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { useRouter } from "@/shared/useHelpers";
import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { CourseParticipantTabNames } from "../kurs/details/CourseParticipantDetailPage.vue";
import { CourseResponsibleFilter } from "@/shared/enums/courseResponsibleFilter.enum";
import { getDashboardUserId } from "@/shared/helpers/dashboardHelpers";

export default defineComponent({
  components: { BaseTableFiltered, BaseTooltipIconButton },
  name: "CourseWithLowAttendancePage",
  setup() {
    const router = useRouter();
    const coursesWithLowAttendance = ref<ApiGetDashboardCourseAttendanceDto[] | null>();
    const search = ref("");
    const users = ref<ApiGetCustomerDto[]>();
    const currentEmployeeId = ref<number>();

    const getParticipantName = (currentId: number) => {
      const participant = users.value?.find((user) => user.id === currentId);
      if (!participant) {
        return "Fant ikke navn på deltaker";
      }
      return `${participant?.customer?.firstName} ${participant?.customer?.lastName}`;
    };

    const displayCourseAttendance = (dashboardCourseAttendance: ApiGetDashboardCourseAttendanceDto) => {
      router.push({
        name: SingleCourseRouteNames.CourseAttendance,
        params: {
          id: dashboardCourseAttendance.courseId.toString(),
        },
      });
    };

    const getUsers = async () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        users.value = (await api.customer.getCustomerPersonsAsync()).data;
      });
    };

    const getCoursesWithLowAttendance = async () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        currentEmployeeId.value = await getDashboardUserId();
        coursesWithLowAttendance.value = (
          await dashboardApi.dashboard.getDashboardAsync({
            userId: currentEmployeeId.value,
            courseResponsibleFilter: CourseResponsibleFilter.SupervisorOrLecturer,
          })
        ).data.coursesWithParticipantsWithLowAttendance;
      });
    };

    onMounted(async () => {
      await Promise.all([getCoursesWithLowAttendance(), getUsers()]);
    });

    const navigateToParticipantAttendance = (courseId: number, participantId: number) =>
      router.push({
        name: SingleCourseRouteNames.CourseParticipantDetails,
        params: { id: courseId.toString(), participantId: participantId.toString() },
        query: { tab: CourseParticipantTabNames.Attendence },
      });

    return {
      search,
      headers,
      DashboardRouteNames,
      coursesWithLowAttendance,
      displayCourseAttendance,
      formatLocalizedDate,
      getParticipantName,
      navigateToParticipantAttendance,
    };
  },
});

const headers = [
  { text: "Kurs-ID", value: "courseId" },
  { text: "Kursnavn", value: "courseName" },
  { text: "Deltagere med lavt fremmøte", value: "courseParticipantsWithLowAttendance" },
  { text: "Handlinger", value: "actions" },
];
